
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import styled from '@emotion/styled';
import { STYLE_GUIDE } from 'enums/styleGuide';
import Link from 'next/link';
import { useRouter } from 'next/router';
const StyleGuideMenu = () => {
    const { asPath } = useRouter();
    const renderLinks = Object.values(STYLE_GUIDE).map(({ title, id }) => {
        const BASE_URL = 'styleguide/';
        const path = id === 'home' ? '/' : `/${BASE_URL}${id}`;
        return (<StyledLink key={id} isActiveLink={asPath.split(BASE_URL)[1] === id}>
        <Link as={path} href={`${path}/`}>
          {title}
        </Link>
      </StyledLink>);
    });
    return <StyledMenu>{renderLinks}</StyledMenu>;
};
export default StyleGuideMenu;
const StyledMenu = styled.nav(({ theme }) => ({
    display: 'flex',
    overflow: 'auto',
    scrollBehavior: 'smooth',
    background: theme.colors.white,
    borderTop: '1px solid' + theme.colors.styleguide.border,
    minWidth: '200px',
    [theme.mediaQueries.md]: {
        position: 'sticky',
        zIndex: 2,
        top: 0,
        left: 0,
        height: '100vh',
        paddingTop: theme.space[2],
        paddingRight: theme.space[5],
        paddingLeft: theme.space[5],
        flexDirection: 'column'
    }
}));
const StyledLink = styled.div<{
    isActiveLink: boolean;
}>(({ theme, isActiveLink }) => ({
    paddingTop: theme.space[3],
    paddingBottom: theme.space[3],
    ...theme.fontStyle.p3,
    a: {
        whiteSpace: 'nowrap',
        padding: theme.mixins.pxSpread([theme.space[1], theme.space[2]]),
        marginLeft: theme.space[3],
        textTransform: 'capitalize',
        color: theme.colors.primary,
        backgroundColor: isActiveLink
            ? theme.colors.white
            : theme.colors.background.primary,
        textDecoration: 'none',
        borderRadius: theme.space[2],
        width: 'fit-content',
        border: '1px solid transparent',
        borderColor: isActiveLink
            ? theme.colors.primary
            : theme.colors.styleguide.border
    },
    'a:hover': {
        background: theme.colors.primary,
        color: theme.colors.white
    },
    [theme.mediaQueries.lg]: {
        marginBottom: theme.space[2],
        marginTop: theme.space[2],
        a: {
            border: isActiveLink
                ? '1px solid' + theme.colors.primary
                : '1px solid' + theme.colors.styleguide.border
        },
        'a:active': {
            background: theme.colors.primary,
            color: theme.colors.white
        }
    }
}));

    async function __Next_Translate__getStaticProps__197303e54a7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'shared/library//StyleGuide/StyleGuideMenu',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197303e54a7__ as getStaticProps }
  